import { debounce as Q } from "lodash-es";
import D from "tabbable";
import { defineComponent as Z, ref as t, computed as g, watch as x, onMounted as ee, onUnmounted as le, useCssModule as oe, resolveComponent as z, openBlock as te, createElementBlock as ne, normalizeClass as s, createElementVNode as n, mergeProps as se, renderSlot as w, normalizeStyle as O, toDisplayString as ae, createCommentVNode as re, createVNode as X, withCtx as de, nextTick as A } from "vue";
import { CdrBreakpointSm as ie, CdrSpaceTwoX as P, CdrSpaceOneX as ce } from "../../../node_modules/@rei/cdr-tokens/dist/js/cdr-tokens.mjs";
import ue from "./onTransitionEnd.mjs";
import me from "../button/CdrButton.vue.mjs";
import fe from "../icon/comps/x-lg.vue.mjs";
import ve from "../../utils/mapClasses.mjs";
import pe from "./styles/CdrModal.module.scss.mjs";
import ye from "../../../_virtual/_plugin-vue_export-helper.mjs";
const he = Z({
  name: "CdrModal",
  components: {
    CdrButton: me,
    IconXLg: fe
  },
  props: {
    /**
     * Toggles the state of the modal
     * @demoIgnore true
     */
    opened: {
      type: Boolean,
      required: !0
    },
    /**
     * Sets `aria-label` and modal title text. Can also use title slot to set title.
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Toggles the modal title text, which comes from `label` prop or `title` slot.
     */
    showTitle: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Text for aria-describedby attribute. Applied to modal content element
     */
    ariaDescribedby: {
      type: String,
      required: !1,
      default: null
    },
    /**
     * Sets the `role` attribute on the modal content element
     * @values dialog, alertDialog
     */
    role: {
      type: String,
      required: !1,
      default: "dialog"
    },
    /**
     * Sets unique `id` for modal
     */
    id: {
      type: String,
      required: !1,
      default: null
    },
    /** Adds custom class to the `cdr-modal__overlay` div */
    overlayClass: String,
    /** Adds custom class to the `cdr-modal__outerWrap` div */
    wrapperClass: String,
    /** Adds custom class to the `cdr-modal__innerWrap` div */
    contentClass: String,
    /** Sets duration for modal's close animation */
    animationDuration: {
      type: Number,
      default: 300
    }
  },
  emits: {
    /** Fires when modal is closed */
    closed: null
  },
  setup(e, d) {
    const E = "cdr-modal";
    let f, v;
    const p = t(!e.opened), i = t(!1), a = t(null), y = t(0), S = t(0), k = t(0), _ = t(0), L = t(0), H = t(0), $ = t(!1), c = t(null), h = t(null), u = t(null), T = t(null), C = () => {
      A(() => {
        var l, o, m, r, b;
        S.value = window.innerHeight, $.value = window.innerWidth < ie, y.value = (l = T.value) == null ? void 0 : l.offsetHeight, k.value = (o = u.value) == null ? void 0 : o.scrollHeight, _.value = (m = u.value) == null ? void 0 : m.offsetHeight, L.value = (r = u.value) == null ? void 0 : r.offsetWidth, H.value = (b = u.value) == null ? void 0 : b.clientWidth;
      });
    }, M = (l) => {
      d.emit("closed", l);
    }, N = ({
      key: l
    }) => {
      switch (l) {
        case "Escape":
        case "Esc":
          M();
          break;
      }
    }, B = (l) => {
      const {
        documentElement: o
      } = document;
      if (c.value.contains(l.target) || !o)
        return;
      const m = D(o), r = D(c.value), b = m.indexOf(l.target), J = m.indexOf(r[0]), q = b < J ? r[r.length - 1] : r[0];
      q && q.focus();
    }, I = Q(() => {
      C();
    }, 300), R = () => {
      const {
        documentElement: l,
        body: o
      } = document;
      a.value = {
        x: window.scrollX || (l || {}).scrollLeft || (o || {}).scrollLeft || 0,
        y: window.scrollY || (l || {}).scrollTop || (o || {}).scrollTop || 0
      }, l && (l.classList.add("cdr-modal__noscroll"), l.style.top = `-${a.value.y}px`, l.style.left = `-${a.value.x}px`), o && o.classList.add("cdr-modal__noscroll");
    }, V = () => {
      const {
        documentElement: l,
        body: o
      } = document;
      o && o.classList.remove("cdr-modal__noscroll"), l && (l.classList.remove("cdr-modal__noscroll"), l.style.top = "", l.style.left = "");
    }, F = () => {
      document.addEventListener("focusin", B, !0), document.addEventListener("keydown", N);
    }, W = () => {
      const {
        activeElement: l
      } = document;
      R(), i.value = !0, p.value = !1, v = l, A(() => {
        c.value && c.value.focus(), C(), F(), setTimeout(() => {
          h.value && (h.value.scrollTop = 0), C();
        });
      });
    }, K = () => {
      const {
        documentElement: l
      } = document;
      document.removeEventListener("keydown", N), document.removeEventListener("focusin", B, !0), i.value = !1, f = ue(h.value, () => {
        i.value || (f(), V(), f = null, p.value = !0, l && (l.style.scrollBehavior = "auto"), window.scrollTo(a.value.x, a.value.y), l && (l.style.scrollBehavior = ""), v && v.focus());
      }, e.animationDuration + 16);
    }, U = g(() => ({
      ...d.attrs,
      "aria-describedby": e.ariaDescribedby,
      "aria-modal": "true",
      id: e.id
    })), Y = g(() => {
      const l = Number(P), o = Number(P) + Number(ce);
      return $.value ? l : o + l;
    }), j = g(() => S.value - y.value - Y.value), G = g(() => {
      const l = k.value > _.value, o = L.value - H.value > 0;
      return l && o ? 4 : l ? 12 : 0;
    });
    return x(() => e.opened, (l, o) => {
      !!l != !!o && (l ? W() : K());
    }), ee(() => {
      e.opened && W(), window.addEventListener("resize", I);
    }), le(() => {
      window.removeEventListener("resize", I);
    }), {
      style: oe(),
      mapClasses: ve,
      baseClass: E,
      modalClosed: p,
      modalEl: c,
      wrapperEl: h,
      contentEl: u,
      headerEl: T,
      scrollMaxHeight: j,
      scrollPadding: G,
      onClick: M,
      dialogAttrs: U
    };
  }
}), be = ["tabIndex"], ge = ["role", "aria-modal", "aria-label"], Ce = ["tabIndex"];
function we(e, d, E, f, v, p) {
  const i = z("icon-x-lg"), a = z("cdr-button");
  return te(), ne("div", {
    class: s(e.mapClasses(e.style, e.baseClass, !e.opened && "cdr-modal--closed")),
    ref: "wrapperEl"
  }, [n("div", {
    class: s([e.style["cdr-modal__outerWrap"], e.wrapperClass])
  }, [n("div", {
    "aria-hidden": "true",
    onClick: d[0] || (d[0] = (...y) => e.onClick && e.onClick(...y)),
    class: s([e.style["cdr-modal__overlay"], e.overlayClass])
  }, null, 2), n("div", {
    tabIndex: e.opened ? "0" : void 0
  }, null, 8, be), n("div", se({
    ref: "modalEl",
    class: e.mapClasses(e.style, "cdr-modal__contentWrap", "cdr-modal__dialog"),
    tabIndex: "-1",
    role: e.role,
    "aria-modal": !!e.opened,
    "aria-label": e.label
  }, e.dialogAttrs), [w(e.$slots, "modal", {}, () => [n("div", {
    class: s([e.style["cdr-modal__innerWrap"], e.contentClass]),
    style: O(e.modalClosed ? {
      display: "none"
    } : void 0)
  }, [n("section", null, [n("div", {
    class: s(e.style["cdr-modal__content"])
  }, [n("div", {
    class: s(e.style["cdr-modal__header"]),
    ref: "headerEl"
  }, [n("div", {
    class: s(e.style["cdr-modal__title"])
  }, [e.showTitle ? w(e.$slots, "title", {
    key: 0
  }, () => [n("h1", null, ae(e.label), 1)]) : re("", !0)], 2), X(a, {
    class: s(e.style["cdr-modal__close-button"]),
    "icon-only": "",
    "with-background": !0,
    onClick: e.onClick,
    "aria-label": "Close"
  }, {
    icon: de(() => [X(i, {
      "inherit-color": ""
    })]),
    _: 1
  }, 8, ["class", "onClick"])], 2), n("div", {
    class: s(e.style["cdr-modal__text-content"]),
    style: O({
      maxHeight: `${e.scrollMaxHeight}px`,
      paddingRight: `${e.scrollPadding}px`
    }),
    role: "document",
    ref: "contentEl",
    tabindex: "0"
  }, [w(e.$slots, "default")], 6)], 2)])], 6)])], 16, ge), n("div", {
    tabIndex: e.opened ? "0" : void 0
  }, null, 8, Ce)], 2)], 2);
}
const Ee = {
  $style: pe
}, Ie = /* @__PURE__ */ ye(he, [["render", we], ["__cssModules", Ee]]);
export {
  Ie as default
};
